var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/16px/Info/Download/Active",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75,10.1893398 L11.4696699,7.46966991 C11.7625631,7.1767767 12.2374369,7.1767767 12.5303301,7.46966991 C12.8232233,7.76256313 12.8232233,8.23743687 12.5303301,8.53033009 L8.53033009,12.5303301 C8.23743687,12.8232233 7.76256313,12.8232233 7.46966991,12.5303301 L3.46966991,8.53033009 C3.1767767,8.23743687 3.1767767,7.76256313 3.46966991,7.46966991 C3.76256313,7.1767767 4.23743687,7.1767767 4.53033009,7.46966991 L7.25,10.1893398 L7.25,1 C7.25,0.585786438 7.58578644,0.25 8,0.25 C8.41421356,0.25 8.75,0.585786438 8.75,1 L8.75,10.1893398 Z M0.75,16 C0.335786438,16 3.45126062e-15,15.6642136 3.55271368e-15,15.25 C3.65416674e-15,14.8357864 0.335786438,14.5 0.75,14.5 L15.25,14.5 C15.6642136,14.5 16,14.8357864 16,15.25 C16,15.6642136 15.6642136,16 15.25,16 L0.75,16 Z",
    id: "Combined-Shape",
    fill: "#3368FF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadActive);
export default __webpack_public_path__ + "static/media/download-active.afefc10dc4090415dc747d43ca2b49f2.svg";
export { ForwardRef as ReactComponent };